import * as TrackingService from 'common/services/tracking.service';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import {
  SESSION_STORAGE_KEYS,
  LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG,
  TRACKING,
  URL_CONTEXTS,
  LOCAL_STORAGE_KEYS
} from 'common/constants/constants';
import {
  omitFromQs,
  omitFromQsAndSaveInSessionStorage
} from 'common/utils/utils';
import QueryString from 'query-string';
import _ from 'lodash';
import { modifyBranchEnv } from './modify-env.service';

const sessionStorageAccessor = BrowserStorageAccessor().session;

const sendInitialTracking = () => {
  const refAccountId = sessionStorageAccessor.get(
    SESSION_STORAGE_KEYS.REF_ACCOUNT_ID
  );

  if (refAccountId) {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.APP_INIT,
      source: TRACKING.SOURCE.ADMIN_INVITE,
      context: refAccountId
    });

    sessionStorageAccessor.remove(SESSION_STORAGE_KEYS.REF_ACCOUNT_ID);
  }
};

export const getSessionModifyFF = () =>
  JSON.parse(sessionStorageAccessor.get(SESSION_STORAGE_KEYS.MODIFY_FF)) || {};

const modifyFFinSessionStorage = ff => {
  const oldModifyFF = getSessionModifyFF();
  const newModifyFF = { ...oldModifyFF, ...ff };

  sessionStorageAccessor.set(
    SESSION_STORAGE_KEYS.MODIFY_FF,
    JSON.stringify(newModifyFF)
  );
};

const qsModifyFF = () => {
  const qsParams = QueryString.parse(window.location.search);
  const ffParam = qsParams[SESSION_STORAGE_KEYS.MODIFY_FF];
  const ffArray = _.flattenDeep([ffParam]);

  omitFromQs(SESSION_STORAGE_KEYS.MODIFY_FF);
  ffArray.forEach(ff => {
    if (!ff || !ff.includes(',')) {
      return;
    }
    const [ffName, ffValue] = ff.split(',');
    if (ffValue !== 'true' && ffValue !== 'false') {
      return;
    }
    const ffObj = { [ffName.toLowerCase()]: ffValue };
    modifyFFinSessionStorage(ffObj);
  });
};

const persistQSParams = () => {
  modifyBranchEnv();

  // Store onboarding token
  const urlParams = new URLSearchParams(window.location.search);
  const createInvitationTkn = urlParams.get('createInvitationTkn');
  const teamId = urlParams.get('teams');
  const orgId = urlParams.get('oid');
  const context = urlParams.get('context');

  if (createInvitationTkn) {
    omitFromQsAndSaveInSessionStorage(
      SESSION_STORAGE_KEYS.CREATE_INVITATION_TOKEN,
      'createInvitationTkn'
    );
  }

  if (context === URL_CONTEXTS.TEAM_ITERATION && orgId && teamId) {
    const localStorageAccessor = BrowserStorageAccessor(orgId).local;
    localStorageAccessor.set(LOCAL_STORAGE_KEYS.SELECTED_TEAM_ID, teamId);
  }

  if (teamId) {
    localStorage.setItem(LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG, teamId);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_SELECTED_TEAM_ID_NO_ORG);
  }
  qsModifyFF();
};

const onWindowFullyLoaded = () => {
  sendInitialTracking();
};

export const initialize = () => {
  persistQSParams();

  if (document.readyState === 'complete') {
    return onWindowFullyLoaded();
  }

  window.addEventListener('load', onWindowFullyLoaded, false);
};
